<script>
import stockNotificationModal from '@phoenix/mixins/components/product/stockNotificationModal';

export default {
  mixins: [stockNotificationModal],
};
</script>

<template>
  <modal :id="id" :title="$t('Product.stock.notifyModalTitle')" :options="modalOptions" data-cy="stock-notify-modal">
    <template #content>
      <phoenix-form
        v-if="isShown"
        ref="phoenixForm"
        v-model="fields"
        :prefill-enabled="true"
        :on-success-callback="onSuccess"
        :on-cancel-callback="close"
        :captcha-enabled="true"
        :action="action"
        :should-display-submit-button="true"
        :should-display-cancel-button="true"
        :should-reset-form-on-submit="true"
        :should-display-required-text="false"
        data-cy="stock-notify-form"
      >
        <div class="form-layout__grid grid grid--multiline">
          <div class="grid__item">
            <p v-html="descriptionText" />
          </div>
          <div class="grid__item">
            <form-group :attrs="fields.email">
              <text-field v-model="fields.email.value" />
            </form-group>
          </div>
        </div>
      </phoenix-form>
    </template>
  </modal>
</template>
